/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  SupportRequestCreated,
  SupportRequestError,
  SupportRequestRequest
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type supportRequestsCreateResponse201 = {
  data: SupportRequestCreated
  status: 201
}

export type supportRequestsCreateResponse502 = {
  data: SupportRequestError
  status: 502
}

export type supportRequestsCreateResponseSuccess = (supportRequestsCreateResponse201) & {
  headers: Headers;
};
export type supportRequestsCreateResponseError = (supportRequestsCreateResponse502) & {
  headers: Headers;
};

export type supportRequestsCreateResponse = (supportRequestsCreateResponseSuccess | supportRequestsCreateResponseError)

export const getSupportRequestsCreateUrl = () => {




  return `/api/v1/support/requests/`
}

/**
 * POST /api/v1/support/requests/ — in-app "Request Support" relay.
 *
 * Stateless pass-through to Linear: the issue (plus attached Customer
 * Request) is the only record. If Linear is unreachable the user gets a
 * 502 and retries — nothing is stored locally, so nothing can be silently
 * lost. The ack email's reply-to is support@, so follow-ups land in
 * Linear's Asks intake.
 */
export const supportRequestsCreate = async (supportRequestRequest: SupportRequestRequest, options?: RequestInit): Promise<supportRequestsCreateResponse> => {

  return customFetch<supportRequestsCreateResponse>(getSupportRequestsCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(supportRequestRequest)
  }
);}


